import { TMultiSelectItem } from "@centricsoftware/design-system";
import MultiSelect, { MultiSelectProps } from "csi/components/select/MultiSelect";
import { useFormStore, useStatefulFormField } from "csi/middleware/form/index";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useComponentOverlayContext } from "../hooks";
import { OnLoadOptions } from "./store/SelectStoreBase";

export interface FormFieldMultiSelectProps extends MultiSelectProps { }

const FormFieldMultiSelect = observer(({
	aggregateStore,
	...otherProps
}: FormFieldMultiSelectProps) => {
	const formStore = useFormStore();
	const field = useStatefulFormField();
	const isParentOverlay = useComponentOverlayContext();

	const { attributeId, id, label, transientInfo: { disabled, required, value } } = field;
	const [fieldInvalid, fieldMessage] = formStore?.getFieldError(id) || [false, ""];
	const [options, setOptions] = useState<TMultiSelectItem[] | undefined>(formStore?.getFieldOptions(attributeId, false));

	const onLoadOptions: OnLoadOptions = (items: TMultiSelectItem[]): void => {
		setOptions(items);
	};

	const onClose = (): void => {
		// noUpdate is false, send request to server
		formStore?.handleFieldChange(null, field, value);
	};

	function onChange(v: TMultiSelectItem[]): void {
		const values = v.map((item) => item.id);
		// noUpdate is true, do not send request to server
		formStore?.handleFieldChange(null, field, values, true);
	};

	// TODO: remove console error MUI: A component is changing the uncontrolled value state of useAutocomplete to be controlled
	return (
		<MultiSelect
			aggregateStore={aggregateStore}
			dataCsiAutomation={id}
			disabled={disabled}
			error={fieldInvalid}
			errorMessage={fieldMessage}
			label={label}
			onChange={onChange}
			onClose={onClose}
			onLoadOptions={onLoadOptions}
			options={options}
			required={required}
			tabIndex={isParentOverlay ? -1 : undefined}
			value={formStore ? value as string[] : []}
			{...otherProps}
		/>
	);
});

export default FormFieldMultiSelect;